import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';
import 'moment/locale/tr';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Typography, Table, Button, Row, Col, Tag } from 'antd';

/* for "axios" request cancelation check variable */
let source;

class PatientPrescriptions extends Component {
    constructor(props) {
        super(props);
        this.getPrescriptions = this.getPrescriptions.bind(this);

        history.listen((location) => {
            props.patientDispatch.clearPatient();
            props.doctorDispatch.clearDoctor();
            props.prescriptionDispatch.clearPrescriptions();
        });
    }

    componentDidMount() {
        /* Component Mount olurken source'a token iletilir */
        source = axios.CancelToken.source();

        this.props.patientDispatch.clearPatient();
        this.props.doctorDispatch.clearDoctor();

        this.getPrescriptions();
    }

    prescriptionColumns = [
        /* Doktor AdSoyad */
        {
            title: 'Doktor',
            dataIndex: 'DoktorAdSoyad',
            key: 'DoktorAdSoyad',
            sorter: (a, b) => a.DoktorAdSoyad.localeCompare(b.DoktorAdSoyad),
            sortDirections: ['descend', 'ascend'],
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* KayitTarihi */
        {
            title: 'Reçete Tarihi',
            dataIndex: 'ReceteTarihi',
            key: 'ReceteTarihi',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => new Date(a.ReceteTarihi) - new Date(b.ReceteTarihi),
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (ReceteTarihi) => (
                moment(new Date(ReceteTarihi)).format('LL')
            ),
            responsive: ["lg"]
        },
        /* Reçete Açıklama */
        {
            title: 'Reçete Açıklama',
            dataIndex: 'ReceteAciklama',
            key: 'ReceteAciklama',
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* Durum */
        {
            title: 'Durum',
            dataIndex: 'AktifMi',
            key: 'Durum',
            sorter: (a, b) => a.AktifMi - b.AktifMi,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (AktifMi) => (
                AktifMi === true ?
                    <Tag color={'success'}>
                        Aktif
                    </Tag>
                    :
                    <Tag color={'error'}>
                        Pasif
                    </Tag>
            ),
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* PasifTarihi */
        {
            title: 'Pasif Tarihi',
            dataIndex: 'PasifTarihi',
            key: 'PasifTarihi',
            sorter: (a, b) => new Date(a.PasifTarihi) - new Date(b.PasifTarihi),
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (PasifTarihi) => (
                PasifTarihi <= (new Date('1923-10-29')) ?
                    <Typography.Text>-</Typography.Text>
                    :
                    PasifTarihi = moment(new Date(PasifTarihi)).format('LL')
            ),
            responsive: ["lg"]
        },
        /* Actions */
        {
            title: 'İşlemler',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <Row gutter={{ xs: 32, sm: 24, md: 16, lg: 8 }}>
                    {/* Reçete Görüntüle */}
                    <Col className="gutter-row">
                        < Button
                            block
                            type="primary"
                            ghost
                            style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                            onClick={
                                () => {
                                    this.props.history.push("/parent/patients/prescriptions/" + record.key);
                                }
                            }
                        >
                            Görüntüle
                        </Button >
                    </Col>
                </Row>
            ),
            responsive: ["xs", "sm", "md", "lg"]
        },
    ];

    getPrescriptions() {
        this.props.prescriptionDispatch.clearPrescriptions();
        this.props.prescriptionDispatch.setLoading(true);

        ParentService.getPatientPrescriptions(this.props.match.params.patientId, source.token)
            .then(
                (res) => {
                    const prescriptions = res.data.map((prescription) => {
                        //Reçete aktif olduğunda "PasifTarihi = null" olacağı için Invalid date yerine geçmiş bir tarih uygulandı
                        moment(prescription.PasifTarihi).toString() === 'Invalid date' ?
                            prescription.PasifTarihi = new Date('1923-10-29')
                            :
                            prescription.PasifTarihi = new Date(prescription.PasifTarihi);

                        return {
                            ...prescription,
                            key: prescription._id,
                            DoktorAdSoyad: prescription.DoktorID.AdSoyad,
                            ReceteTarihi: moment(prescription.ReceteTarihi).toString(),
                            PasifTarihi: prescription.PasifTarihi,
                        }
                    });
                    this.props.prescriptionDispatch.setPrescriptions(prescriptions);

                    this.props.prescriptionDispatch.setLoading(false);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    /* Request cancel edildiğinde message olarak 'Cancel' dönüyor. Hata bildirimi verilmesini engellemek için */
                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });
                    }
                    this.props.prescriptionDispatch.setLoading(false);
                    this.clearTimer = setTimeout(() => {
                        this.props.history.push("/parent/patients");
                    }, 3000);
                })
    }

    componentWillUnmount() {
        /* Component Unmount edilirken cancel triggerı tetiklenir */
        if (source) {
            source.cancel();
        }

        clearTimeout(this.clearTimer);
    }

    render() {
        return (
            <div>
                <div>
                    {this.props.prescriptions.length !== 0 &&
                        <Typography.Title style={{ textAlign: 'center' }}>
                            "{this.props.prescriptions[0]?.HastaID.AdSoyad}" ait Reçeteler
                        </Typography.Title>
                    }
                    <Table
                        columns={this.prescriptionColumns}
                        dataSource={this.props.prescriptions && this.props.prescriptions}
                        pagination={{ pageSize: 10, hideOnSinglePage: true }}
                        loading={this.props.prescription.loading}
                    />
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    patient: state.patient,
    doctor: state.doctor,
    prescription: state.prescription,
    prescriptions: state.prescription.prescriptions,
});

const mapDispatch = (dispatch) => ({
    patientDispatch: dispatch.patient,
    doctorDispatch: dispatch.doctor,
    prescriptionDispatch: dispatch.prescription,
});

export default connect(mapState, mapDispatch)(PatientPrescriptions);